import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HomeComponent} from './home/home.component'

import { VotingComponent } from './voting/voting.component';
import { LoginComponent } from './login/login.component';
import { VotesuccessComponent } from './votesuccess/votesuccess.component';
import { UnregvoterComponent } from './unregvoter/unregvoter.component';
import { VoterregComponent } from './voterreg/voterreg.component';
import { VoterlistComponent } from './admin/voterlist/voterlist.component';
import { VotesComponent } from './admin/votes/votes.component';
import { AllvoterComponent } from './allvoter/allvoter.component';
const routes: Routes = [
	{path: '', component: HomeComponent},
	{path: 'compartment', component: VotingComponent},
	{path: 'login', component: LoginComponent},
	{path: 'votesuccess', component: VotesuccessComponent},
	{path: 'regsuccess', component: VotesuccessComponent},
	{path: 'unregvoter', component: UnregvoterComponent},
	{path: 'voterreg', component: VoterregComponent},
	{path: 'admin/voterapproval', component: VoterlistComponent},
	{path: 'admin/resultofvotes', component: VotesComponent},
	{path: 'voters', component: AllvoterComponent},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
